export class CreateAccountInput {
    'cloudProvider';
    'role';
    'regions';
    'tags';
    'name';
    'tenantId';
    'applicationId';
    'overrideDefaultNetworkConfig';
    'isInternal';
    'isCustomerOwned';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "string",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "applicationId",
            "baseName": "applicationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "overrideDefaultNetworkConfig",
            "baseName": "overrideDefaultNetworkConfig",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isInternal",
            "baseName": "isInternal",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isCustomerOwned",
            "baseName": "isCustomerOwned",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateAccountInput.attributeTypeMap;
    }
    constructor() {
    }
}
